var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"latex-demo"},[_c('div',{staticClass:"demo-container"},[_c('div',{staticClass:"output-section"},[_c('div',{attrs:{"id":"customOutput"},domProps:{"innerHTML":_vm._s(_vm.parsedLatex)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }